import Factory from '@/utils/request'

const baseURL = process.env.VUE_APP_PRO_API

export default Factory(
  {
    baseURL
  },
  () => false
)
